import { createFileRoute } from "@tanstack/react-router";

import TodosExport from "@/features/todos/todos-export";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/export",
)({
  component: ReceivableExportPage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableExportPage() {
  return <TodosExport type="receivable" />;
}
